var CompanySize = {
	"Company size": "Taille de l'entreprise",
	"1-19 employees": "1 à 19 employés",
	"20-99 employees": "20 à 99 employés",
	"100-499 employees": "100 à 499 employés",
	"500-999 employees": "500 à 999 employés",
	"1,000-9,999 employees": "1 000 à 9 999 employés",
	"10,000 employees or more": "10 000 employés ou plus"
};

export { CompanySize as default };
